import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export const clientConversationValidator = {
  subject: plaintextValidator(config)
};
